import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { RouterModule } from "@angular/router";
import { FormsModule } from "@angular/forms";
import {
  MatButtonModule,
  MatChipsModule,
  MatIconModule,
  MatTabsModule
} from "@angular/material";
import {
  NgbAccordionModule,
  NgbDropdownModule,
  NgbTooltipModule,
  NgbTypeaheadModule,
  NgbDatepickerModule
} from "@ng-bootstrap/ng-bootstrap";
import { LocationUserAssignmentModalComponent } from "./location-user-assignment-modal/location-user-assignment-modal.component";
import { SearchListComponent } from "./search-list/search-list.component";
import { CustomDropdownComponent } from "./custom-dropdown/custom-dropdown.component";
import { CustomAccordionComponent } from "./custom-accordion/custom-accordion.component";
import { HeaderComponent } from "./header/header.component";
import { SessionTimeoutModalComponent } from "./session-timeout-modal/session-timeout-modal.component";
import { InfoModalComponent } from "./info-modal/info-modal.component";
import { NotFoundComponent } from "./not-found/not-found.component";
import { NoAccessComponent } from "./no-access/no-access.component";
import { VerifyCodeSentModalComponent } from "./verify-code-sent-modal/verify-code-sent-modal.component";
import { ReportDetailsModalComponent } from "./report-details-modal/report-details-modal.component";
import { SpinnerComponent } from "./spinner/spinner.component";

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    NgbAccordionModule,
    NgbDropdownModule,
    NgbTooltipModule,
    NgbDatepickerModule,
    FormsModule,
    MatTabsModule
  ],
  exports: [
    // Modules
    NgbDropdownModule,
    FormsModule,
    NgbTooltipModule,
    MatTabsModule,
    MatButtonModule,
    MatIconModule,
    MatChipsModule,
    NgbAccordionModule,
    NgbTypeaheadModule,
    NgbDatepickerModule,
    // Components
    SearchListComponent,
    NotFoundComponent,
    NoAccessComponent,
    InfoModalComponent,
    LocationUserAssignmentModalComponent,
    SearchListComponent,
    CustomDropdownComponent,
    CustomAccordionComponent,
    HeaderComponent,
    SpinnerComponent
  ],
  declarations: [
    SearchListComponent,
    NotFoundComponent,
    NoAccessComponent,
    InfoModalComponent,
    LocationUserAssignmentModalComponent,
    CustomDropdownComponent,
    CustomAccordionComponent,
    HeaderComponent,
    SessionTimeoutModalComponent,
    VerifyCodeSentModalComponent,
    ReportDetailsModalComponent,
    SpinnerComponent
  ]
})
export class SharedComponentsModule {}



// WEBPACK FOOTER //
// /Users/maxsheikhizadeh/Desktop/GEN/physician-portal/src/app/shared/components/shared-components.module.ts